/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Menu,
    MenuItem,
    Paper,
    Stack,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import go_back from "../../../assets/icons/go_back.svg";
import Container from "../../../components/container/Container";
import IconButton from "../../../components/IconButton";

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useAuthContext } from "src/auth/useAuthContext";
import CampaignData from "./CampaignData";
import CampaignPreView from "./CampaignPreView";
import CampaignPercentage from "./CampaignPercentage";
import getCampianAssignGroups from "src/services/campian/getAssignGroupData";
import getCampaigns from "src/services/campian/getCampaigns";
import Breadcrumb from "src/components/breadcrumb/breadcrumb";
const CampaignView = () => {
    const { _id } = useParams();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    let image = ""
    if (type == "discount") {
        image = "https://ticketsque-public.s3.ap-south-1.amazonaws.com/discount-demo-image.png"
    }

    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const { vendor, user, logout } = useAuthContext();

    const [cardDetail, setCardDetail] = useState();
    const [loading, setLoading] = useState(true);
    const open = Boolean(anchorEl);
    const matches = useMediaQuery("(min-width:1100px)");
    const [state, setState] = useState({
        bottom: false,
    });
    const anchor = "bottom";

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleGoback = () => {
        navigate(-1);
    };

    useEffect(() => {
        const getData = async (user, logout, _id) => {
            const data = await getCampaigns(user, "", "", "", "", logout, _id, undefined, type);
            if (data) {
                setCardDetail(data?.data?._payload[0]);
                setLoading(false);
            } else {
                setLoading(false);
            }
        };

        if (user) {
            getData(user, logout, _id);
        }
    }, []);

    const handleEditCampaign = () => {
        navigate(`/campaign/edit-campaign/${cardDetail?._id}`, {
            replace: true,
            state: {
                cardDetail,
            },
        });
    };

    const [templateHeader, setTemplateHeader] = useState({})
    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianAssignGroups(user, 0, 100000, "", "active", "", "true", cardDetail?.meta_template_data?.meta_phone_number_id);
            setTemplateHeader(data)

        }
        if (cardDetail?.meta_template_data) {
            fetchData()
        }
    }, [cardDetail])

    return (
        <Container>
            {loading ? (
                <Stack sx={{ position: "absolute", left: "50%", top: "50%" }}>
                    <CircularProgress />
                </Stack>
            ) : (
                <Stack spacing={2.5}>
                    <Breadcrumb
                        breadcrumbData={[
                            { href: "/dashboard/campaign/all", name: "All Campaign" },
                            { name: "Detailed Campaign ", current: true },
                        ]}
                    />

                    <Paper sx={{ p: { xs: 0.5, sm: 3 } }}>
                        <Stack spacing={2}>
                            <Stack
                                width="100%"
                                spacing={2.7}
                                direction="row"
                                justifyContent="space-between"
                            >
                                <Stack direction="row" alignItems="center">
                                    <IconButton onClick={handleGoback} icon={go_back} />
                                    <Typography color="primary" variant="h4">
                                        Campaign Details
                                    </Typography>
                                </Stack>
                                {cardDetail?.campaign_status !== "completed" &&
                                    cardDetail?.campaign_status !== "failed" && cardDetail?.campaign_status !== "stopped" && type != "discount" && (
                                        <Box>
                                            {/* <Box
                        component="img"
                        src={Button_icon}
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        sx={{ height: "36px", cursor: "pointer" }}
                      /> */}
                                            <Button
                                                variant="contained"
                                                aria-controls={open ? "basic-menu" : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open ? "true" : undefined}
                                                onClick={handleClick}
                                                sx={{
                                                    height: "36px",
                                                    cursor: "pointer",
                                                }}
                                            ><MoreVertIcon />
                                            </Button>

                                            <Menu
                                                sx={{ mt: 1, zIndex: 99999 }}
                                                id="basic-menu"
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                                MenuListProps={{
                                                    "aria-labelledby": "basic-button",
                                                }}
                                            >
                                                <MenuItem onClick={handleEditCampaign}>
                                                    Edit Campaign
                                                </MenuItem>
                                                {/* {parseInt(eventData.remaining_capacity) ===
                    parseInt(eventData.capacity) &&
                    new Date(eventData?.distribution_start) >= new Date() && (
                      <MenuItem onClick={handleDelete}>Delete Event</MenuItem>
                    )} */}
                                            </Menu>
                                        </Box>
                                    )}
                            </Stack>
                            {cardDetail?.campaign_counts && (
                                <Box sx={{ pl: { xs: 2, sm: 3, md: 5 } }}>
                                    <CampaignPercentage data={cardDetail?.campaign_counts} cardDetail={cardDetail} />
                                </Box>
                            )}
                            <Stack
                                width="100%"
                                spacing={2.7}
                                direction="row"
                                justifyContent="space-between"
                            >
                                <Box sx={{ pl: { xs: 2, sm: 3, md: 5 } }} spacing={2}>
                                    {cardDetail?.variables && <CampaignData data={cardDetail} />}
                                </Box>
                                {matches && (
                                    <CampaignPreView
                                        campaign_data={cardDetail?.variables}
                                        template={cardDetail}
                                        image={image}
                                        templateHeader={templateHeader}
                                    />
                                )}
                            </Stack>
                        </Stack>
                        {!matches && (
                            <>
                                <Button
                                    variant="contained"
                                    size="medium"
                                    sx={{ ml: { xs: 2.5, sm: 5 }, mt: 1 }}
                                    onClick={toggleDrawer(anchor, true)}
                                >
                                    Preview
                                </Button>
                                {!matches && (
                                    <CampaignPreView
                                        toggleDrawer={toggleDrawer}
                                        anchor={anchor}
                                        state={state}
                                        image={image}
                                        campaign_data={cardDetail?.variables}
                                        template={cardDetail}
                                        templateHeader={templateHeader}
                                    />
                                )}
                            </>
                        )}
                    </Paper>
                </Stack>
            )}
        </Container>
    );
};
export default CampaignView;
